<!DOCTYPE html>
<template>
  <div class="generic">
    <section class="anchor" id="jumbo">
    </section>

    <b-jumbotron bg-variant="primary"
                 text-variant="light"
                 header="Security Stuff"
                 lead="Stuff about cybersecurity.">
      <b-button variant="success"
                @click="read"
                class="shadow-lg">Read</b-button>
    </b-jumbotron>

    <br>
    <br>

    <section class="anchor" id="read">
      <!-- Create `v-for` and apply a `key` for Vue. Here we are using a
      combination of the slug and index. -->
      <b-card class="shadow-lg" no-body>
        <div v-for="(post,index) in posts"
          :key="post.slug + '_' + index">
          <router-link :to="'/stuff/' + post.slug">
            <article class="media">
            <div class = "post">

              <!--Title row-->
              <div class = "item1">
                  <h1>{{ post.title }}</h1>
              </div>

              <!--Image and summary row-->
                <!--Image-->
                <div class = "item2">
                  <figure>
                    <!-- Bind results using a `:` -->
                    <!-- Use a `v-if`/`else` if there is a `featured_image` -->
                    <img v-if="post.featured_image"
                      :src="post.featured_image"
                      alt="" >
                    <img v-else
                      src="../assets/BlueTeamLogo.png"
                      alt="">
                  </figure>
                </div>
                <!--Summary-->
                <div class = "item3">
                  <p>{{ post.summary }}</p>
                </div>

            </div>
            </article>
          </router-link>
        </div>
      </b-card>

    </section>

  </div>
</template>

<script>
import { butter } from '@/buttercms'
export default {
  name: 'Stuff',
  metaInfo() {
    return {
      title: 'Security Stuff',
      meta: [
        { name: "description", content: "Security Stuff", vmid: 'description' },
        { name: "twitter:title", content: "Security Stuff", vmid: 'twitter:title' },
        { name: "og:image", content: "https://getblueteam.com/img/BlueTeamLogo.bb7395fa.png" },
        { name: "twitter:description", content: 'Cybersecurity tips for businesses and career advice for professionals', vmid: 'twitter:description' },
        { name: "keywords", content: "cybersecurity, talent, fintech, digital health, appsec, IAM, identity management, devsecops, devops, cloud security" }
      ]
    }
  },
  data() {
    return {
      page_title: 'Security Stuff',
      posts: []
    }
  },
  props: {},
  computed: {},
  methods: {
    read() {
      window.location.hash = ''
      window.location.hash = 'read'
    },
    getPosts() {
      butter.post.list({
        page: 1,
        page_size: 10
      }).then(res => {
        this.posts = res.data.data
      })
    }
  },
  created() {
    this.getPosts()
  }
}

</script>

<style scoped lang="scss">
@import "@/styles/global.scss";

.generic {
    color: theme-color-level('primary', 0);
}

.anchor {
  display: grid;
  grid-row-gap: 5rem;

  img {
      width: 75%;
  }

.post {
  display: grid;
  grid-row-gap: 1rem;
  grid-template-columns: 1fr 3fr;
  grid-template-rows: auto auto;
  line-height: 2;
}
.item1{
  grid-column-end: span 2;
}
.item2{
}
.item3{
}

}

</style>
